import $ from 'jquery';

import { default as DefaultMap, handleWebGlError } from 'JIX/map/DefaultMap.js';
import ClusteredJobs from 'JIX/map/ClusteredJobs.js';

const stash = window.Stash['jobsearch/map'];

$(() => {
    const container = 'map_canvas';
    let map;
    try {
        map = new DefaultMap({ container });
    } catch (error) {
        handleWebGlError(error, container);
        return;
    }
    new ClusteredJobs({}).addTo(map).setData(stash.results);
});
